// extracted by mini-css-extract-plugin
module.exports = {"uniBlue":"#00adef","textSection":"textSection-module--text-section--1PWne"};